import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";


export default function Dashboard() {
return (
<Card>
<CardContent>
<Typography variant="h6" fontWeight={600} gutterBottom>
Dashboard
</Typography>
<Typography color="text.secondary">
Visualizations like student distribution, course activity, and engagement metrics can be added here.
</Typography>
</CardContent>
</Card>
);
}